import React, { useRef, useState } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { Card, Col, Row } from 'react-bootstrap';
import { DirectionalHint, Dropdown, IconButton, Label, Stack, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../components/Common/CLabel';
import ToolBar from '../../../components/Common/Toolbar';
import SidePanelModifyContainer from './SidePanelModifyContainer';
import { getKeyByDictionary, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import SidePanelConfigure from './SidePanelConfigure';
import { TeachBubbleMultiSteps } from '../../../components/Templates/TeachBubble/indexMultiSteps';
import MessageBox from '../../../components/Common/Message/MessageBox';
import { __AppElementType, __ComponentTypes, __MessageTypes, __enum_TeachBoardConfig, enum__BOARD_TEMPLATE_TYPE, enum__ComponentType } from '../../../common/Dictionaries';
import { __onGoToBoard } from '../../../common/SystemRedirections';
import './style.css'
import { addBoardTemplate, canTemplateCreation } from '../../../services/sKPI/board.service';
import { action_setBoardConfigTemplateProperty, action_setBoardConfigTemplateTypeList } from '../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useGetTemplateTypeForBoardConfig } from './useOfBoardConfig';
import CValidator from '../../../components/Common/CValidator';
import { css } from '@uifabric/experiments/lib/Utilities';
import moment from 'moment';
import ELEMENT_STADISTICS from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_STADISTICS';
import ContractInfo_EP from '../../../components/Products/sKPI/Board/_ComponentTypes/SG3_HEADER';
import ProfileVerify from '../../../components/Templates/Site/ProfileVerify';
import ELEMENT_CONTRACT_SEGMENT from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_SEGMENT';
import ELEMENT_CONTRACT_CATEGORY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_CATEGORY';
import ELEMENT_CONTRACT_PORTFOLIO_SUMMARY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_PORTFOLIO_SUMMARY';
import ELEMENT_CONTRACT_KPI_DETAIL from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_KPI_DETAIL';
import ELEMENT_KPI_FTE_CHART from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_FTE_CHART';
import ELEMENT_KPI_AMOUNT from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_AMOUNT';
import ELEMENT_KPI_FTE_TREE from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_FTE_TREE';
import CONTRACT_SERVICES from '../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_SERVICES';
import ELEMENT_LAST_MOVEMENTS from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_LAST_MOVEMENTS';
import ELEMENT_ROLES from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_ROLES';
import CONTRACT_SERVICES_STATUS from '../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_SERVICES_STATUS';
import ELEMENT_CONTRACT_LAST_EDP from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_LAST_EDP';
import ELEMENT_CONTRACT_LIST_LAST_EDP from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_LIST_LAST_EDP';
import ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL';
import ELEMENT_CONTRACT_SERVICE_SUMMARY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_SERVICE_SUMMARY';
import ELEMENT_CONTRACT_EXPENSE_BALANCE from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EXPENSE_BALANCE';
import ELEMENT_CONTRACT_EDP_COVER from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_COVER';
import PRODUCTS from '../../../components/Products/sKPI/Board/_ComponentTypes/PRODUCTS';
import CONTRACT_KPI_COVERAGE from '../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_KPI_COVERAGE';
import CONTRACT_LAST_EDP from '../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_LAST_EDP';
import ELEMENT_BOOK_SUMMARY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_BOOK_SUMMARY';
import ELEMENT_KPI_COMMENT_EVENT from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_COMMENT_EVENT';
import ELEMENT_KPI_VARIABLE_DETAILS from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_VARIABLE_DETAILS';
import ELEMENT_KPI_SUMMARY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_SUMMARY';
import ELEMENT_BOOK_STATUS_SUMMARY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_BOOK_STATUS_SUMMARY';
import OCR_CHART_DUMMY from '../../../components/Products/sKPI/Board/_ComponentTypes/OCR_CHART/indexDummy';
import SG3KPI_RADIAL_DUMMY from '../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_RADIAL/indexDummy';
import SG3KPI_CONSOLIDATE_MONTH_DUMMY from '../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_CONSOLIDATE_MONTH/indexDummy';
import ELEMENT_OBLIGATIONS_CONTROL from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_OBLIGATIONS_CONTROL';
import ELEMENT_KPI_SCOPE_DUMMY from '../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_SCOPE/indexDummy';
import SG3KPI_RADIALOPF from '../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_RADIALOPF';

function BoardConfiguration() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { _templateTypeList: templateTypeList } = useSelector((state) => state.configBoardScope);
    const { _templateConfig: templateConfig } = useSelector((state) => state.configBoardScope);

    const ResponsiveGridLayout = WidthProvider(Responsive);

    const [isPanelModifyContainerOpen, setIsPanelModifyContainerOpen] = useState(false);
    const [isPanelConfigureBoardOpen, setIsPanelConfigureBoardOpen] = useState(false);

    const [layouts, setLayouts] = useState({lg: [ {"i": "1","x": 0,"y": 0,"w": 6,"h": 4} ]});
    const [selectedContainer, setSelectedContainer] = useState(layouts.lg[0]);
    const [layoutsComponentTypes, setLayoutsComponentTypes] = useState([{i: "1", "title": "Contenedor 1", editMode: false}]);

    const [created, setCreated] = useState(false);

    const [nextId, setNextId] = useState(2);
    const [availableIds, setAvailableIds] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isValidForm, setIsValidForm] = useState({
        templateType: true,

        title: true,
        appElementType: true,
        elementType: true,

        containersCompleted: true,
    });

    const gridLayoutRef = useRef(null);

    const isReportType = window.location.href.toLocaleLowerCase().indexOf('configuration/report') !== -1;

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 50,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    useGetTemplateTypeForBoardConfig(templateTypeList);

    const removeItemFromLayout = (id) => {
        const newLayouts = { ...layouts };
        const itemIndex = newLayouts.lg.findIndex((item) => item.i === id);
        newLayouts.lg.splice(itemIndex, 1);
        setLayouts(newLayouts);

        setLayoutsComponentTypes(layoutsComponentTypes.filter(x => x.i !== id))

        setAvailableIds((prevIds) => [...prevIds, id]);
    };

    const onAddItemToLayout = () => {
        const newLayouts = { ...layouts };
        const newLayoutComponentTypes = [...layoutsComponentTypes];

        let newId;

        if (availableIds.length > 0) {
          newId = availableIds[0];
          setAvailableIds((prevIds) => prevIds.slice(1));
        } else {
          newId = nextId;
          setNextId(nextId + 1);
        }
    
        // Encuentra la última fila
        let lastRow = 0;
        newLayouts.lg.forEach((item) => {
            if (item.y > lastRow) {
                lastRow = item.y;
            }
        });
    
        // Encuentra el espacio disponible en la última fila
        let availableSpace = 36;
        newLayouts.lg.forEach((item) => {
            if (item.y === lastRow) {
                availableSpace -= item.w;
            }
        });
    
        // Calcula la posición X e Y del nuevo item
        let newItemX = 0;
        let newItemY = lastRow;
    
        if (availableSpace >= 6) {
            // Hay suficiente espacio en la fila actual
            newItemX = 36 - availableSpace;
        } else {
            // No hay suficiente espacio en la fila actual, pasa a la siguiente fila
            newItemX = 0;
            newItemY = lastRow + 5;
        }
    
        newLayoutComponentTypes.push({i: newId.toString(), title: `Contenedor ${newId}`, editMode: false})

        setLayoutsComponentTypes(newLayoutComponentTypes);

        // Agrega el nuevo item a las layouts
        newLayouts.lg.push({ i: newId.toString(), x: newItemX, y: newItemY, w: 6, h: 4 });
        setLayouts(newLayouts);
    };

    const onSaveTemplate = async () => {
        if (validateBoard()) {  
            try {
                const htmlStructure = [{
                    "title": templateConfig.title, 
                    "i":1,
                    "cols": { "lg": 36, "md": 30, "sm": 18, "xs": 12, "xxs": 6 },
                    "rowHeight": 50, 
                    "width": "100%", 
                    "isDraggable": false,
                }];
                
                const htmlContainer = [{
                    "iStructure": 1, 
                    "layouts": layouts.lg,
                    "components": layoutsComponentTypes.map(x => ({"iContainer": x.i, "componentTypeId": x.type, "componentField": getKeyByDictionary(x.type)}))
                }]
                
                const serviceResponse = await canTemplateCreation(templateConfig.templateTypeSelected.key, templateConfig.elementSelected.id)
                
                if (serviceResponse.data.succeeded) {
                    const boardTemplate =
                    {
                        id: 0,
                        templateNemo: "",
                        templateCode: "", 
                        name: templateConfig.title,
                        creationDate: moment(Date.now()).format('MM/DD/YYYY'),
                        defaultTemplate: false,
                        boardTypeId: templateConfig.appElementSelected.key,
                        htmlTemplate: JSON.stringify(layoutConfiguration),
                        htmlStructure: JSON.stringify(htmlStructure),
                        htmlContainer: JSON.stringify(htmlContainer),
                    }

                    const addTemplateServiceResponse = await addBoardTemplate(templateConfig.templateTypeSelected.key, boardTemplate, templateConfig.elementSelected.id);
                    
                    if (addTemplateServiceResponse.data.succeeded) {
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))  
                        setCreated(true);
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-alredyexist-teplatetypeforelement'))
                }
            } catch (error) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }  
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-boardconfig-worknotcomplete'))
        }
    };

    const validateBoard = () => {
        let flag = true;

        if (templateConfig.title === "" || templateConfig.title === "Nombre del tablero") {
            isValidForm.title = false;
        }
        else {
            isValidForm.title = true;
        }

        if (templateConfig.templateTypeSelected === null || templateConfig.templateTypeSelected.key === 0) {
            isValidForm.templateType = false;
        }
        else {
            isValidForm.templateType = true;
        }

        if (!isReportType) {
            if (templateConfig.elementSelected === null || templateConfig.elementSelected.key === 0) {
                isValidForm.elementType = false;
            }
            else {
                isValidForm.elementType = true;
            }

            if (templateConfig.appElementSelected === null || templateConfig.appElementSelected.key === 0) {
                isValidForm.appElementType = false;
            }
            else {
                isValidForm.appElementType = true;
            }
        }

        const containersCompleted = layoutsComponentTypes.every(obj => 
            obj.hasOwnProperty('name') && obj.hasOwnProperty('title') && obj['name'] !== ""
        );

        isValidForm.containersCompleted = containersCompleted;


        flag = flag === true ? (containersCompleted && isValidForm.title && isValidForm.templateType && isValidForm.elementType && isValidForm.appElementType) : flag;

        setIsValidForm(isValidForm);

        return flag;
    };

    const onOpenContainerModifyPanel = (container) => {
        setSelectedContainer(container)
        setIsPanelModifyContainerOpen(true);
    };

    const onOpenConfigureBoardPanel = (container) => {
        setIsPanelConfigureBoardOpen(true);
    };

    const onSetContainerData = (container, componentType, containerTitle) => {
        let componentTypes_aux = [...layoutsComponentTypes];
        let layouts_aux = [...layouts.lg];

        const componentType_aux = componentTypes_aux.find(item => item.i === container.i);
        const container_aux = layouts_aux.find(item => item.i === container.i);

        container_aux.minH = componentType.minHeigthPoints;
        container_aux.h = componentType.minHeigthPoints;
        container_aux.w = componentType.minWidthPoints;
        container_aux.minW = componentType.minWidthPoints;
        if (componentType.id === enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL) {
            container_aux.isResizable = false;
        }
        else {
            container_aux.isResizable = true;
        }
        
        if (!isNullUndefinedOrEmpty(componentType_aux)) {
            componentType_aux.name = componentType.name;
            componentType_aux.minHeigthPoints = componentType.minHeigthPoints;
            componentType_aux.minWidthPoints = componentType.minWidthPoints;
            componentType_aux.type = componentType.id;
            componentType_aux.title = containerTitle;
        }
        else {
            componentTypes_aux.push({i: container.i, name: componentType.name, title: containerTitle, id: componentType.id});
        }

        setLayouts({lg: layouts_aux});
        setLayoutsComponentTypes(componentTypes_aux);
    };

    const onSetBoardData = (objBoardSelected, objStructureTitle, objElementTypeSelected) => {
        dispatch(action_setBoardConfigTemplateProperty("title", objStructureTitle))
        dispatch(action_setBoardConfigTemplateProperty("elementSelected", objBoardSelected))
        dispatch(action_setBoardConfigTemplateProperty("appElementSelected", objElementTypeSelected))
    };
    
    const getComponentDummy = (layoutsComponentTypes) => {
        switch (layoutsComponentTypes.type) {
            case enum__ComponentType.SG3_HEADER:
                return <ContractInfo_EP
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_SEGMENT:
                return <ELEMENT_CONTRACT_SEGMENT
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                            inputParam_HideCarteras={true}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_CATEGORY:
                return <ELEMENT_CONTRACT_CATEGORY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY:
                return <ELEMENT_CONTRACT_PORTFOLIO_SUMMARY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL:
                return <ELEMENT_CONTRACT_KPI_DETAIL
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_FTE_CHART:
                return <ELEMENT_KPI_FTE_CHART
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_AMOUNT:
                return <ELEMENT_KPI_AMOUNT
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_FTE_TREE:
                return <ELEMENT_KPI_FTE_TREE
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.CONTRACT_SERVICES:
                return <CONTRACT_SERVICES
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_LAST_MOVEMENTS:
                return <ELEMENT_LAST_MOVEMENTS
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_ROLES:
                return <ELEMENT_ROLES
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_STADISTICS:
                return <ELEMENT_STADISTICS
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.CONTRACT_SERVICES_STATUS:
                return <CONTRACT_SERVICES_STATUS
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.CONTRACT_LAST_EDP:
                return <CONTRACT_LAST_EDP
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP:
                return <ELEMENT_CONTRACT_LAST_EDP
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP:
                return <ELEMENT_CONTRACT_LIST_LAST_EDP
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL:
                return <ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY:
                return <ELEMENT_CONTRACT_SERVICE_SUMMARY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE:
                return <ELEMENT_CONTRACT_EXPENSE_BALANCE
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER:
                return <ELEMENT_CONTRACT_EDP_COVER
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.PRODUCTS:
                return <PRODUCTS
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.CONTRACT_KPI_COVERAGE:
                return <CONTRACT_KPI_COVERAGE
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_BOOK_SUMMARY:
                return <ELEMENT_BOOK_SUMMARY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT:
                return <ELEMENT_KPI_COMMENT_EVENT
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS:
                return <ELEMENT_KPI_VARIABLE_DETAILS
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_KPI_SUMMARY:
                return <ELEMENT_KPI_SUMMARY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY:
                return <ELEMENT_BOOK_STATUS_SUMMARY
                            inputParam_UseFake={true}
                            inputParam_HideHeader={false}
                        />
            case enum__ComponentType.OCR_CHART:
                return <OCR_CHART_DUMMY
                            inputParam_ReportMode ={false}
                            inputParam_ShowGauge ={false}
                        />
            case enum__ComponentType.OCR_CHART_GAUGE:
                return <OCR_CHART_DUMMY
                            inputParam_ReportMode ={false}
                            inputParam_ShowGauge ={true}
                        />  
            case enum__ComponentType.SG3KPI_RADIAL:
                return <SG3KPI_RADIAL_DUMMY />  
            case enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH:
                return <SG3KPI_CONSOLIDATE_MONTH_DUMMY /> 
            case enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL:
                return <ELEMENT_OBLIGATIONS_CONTROL />
            case enum__ComponentType.ELEMENT_KPI_SCOPE:
                return <ELEMENT_KPI_SCOPE_DUMMY />
            case enum__ComponentType.SG3KPI_RADIALOPF:
                return <SG3KPI_RADIALOPF
                            inputParam_HideHeader={false}
                            inputParam_UseFake={true}
                            inputParam_ShowGauge={true}
                        />
            default:
                return undefined
        }
    }

    const generateContainer = (container) => {
        const componentData = layoutsComponentTypes.find(x => x.i === container.i);

        return  <Card style={{border: (!isValidForm.containersCompleted) ? (layoutsComponentTypes.find(x => x.i === container.i).title === "" || layoutsComponentTypes.find(x => x.i === container.i).name === undefined ? "1px solid red" : undefined) : undefined}} className="board-element-form h-100">
                    <Card.Header className={`card-header-compact ${!created ? 'dragHandle' : ''}`}>
                        <Card.Title className="d-flex justify-content-between">
                            <TooltipHost
                                content={ layoutsComponentTypes.find(x => x.i === container.i).title }
                                overflowMode={TooltipOverflowMode.Self}
                                hostClassName={css(classNames.overflow)}
                            >
                                <b>{layoutsComponentTypes.find(x => x.i === container.i).title}</b>
                            </TooltipHost>
                            {
                                !created &&
                                <div id={`btnContainer${container.i}`} className="toolbar d-flex">
                                    <ToolBar
                                        overflowItems={[
                                            {
                                                key: 'editTitle',
                                                text: t('data-lang-btn-configure'),
                                                iconProps: { iconName: 'Settings' },
                                                onClick: () => onOpenContainerModifyPanel(container),
                                            }
                                        ]}
                                        display={true}
                                        styles={{root: {padding: 0, height: "30px"}}}
                                    />
                                    <IconButton iconProps={{ iconName: "Clear" }} onClick={() => removeItemFromLayout(container.i)} />
                                </div>
                            }
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row className='h-100'>
                            <Col className={componentData !== undefined ? (componentData.type === enum__ComponentType.ELEMENT_STADISTICS ? "" : "col-auto m-auto h-100 w-100") : "col-auto m-auto"}>
                                {componentData !== undefined ? getComponentDummy(componentData) : "Not selected"}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
    };

    const onLayoutChange = (layout) => {
        setLayouts(prevState => ({
            ...prevState,
            lg: layout
        }));
    };

    const onChangeTemplateType = (currentControl, selectedNode) => {
        setIsValidForm(prevState => ({
            ...prevState,
            elementType: true
        }));

        templateTypeList.forEach(x => {
            x.checked = false;
            if (x.key === selectedNode.key) {
                x.checked = selectedNode.checked;
            }
        })

        setIsValidForm(prevState => ({
            ...prevState,
            templateType: selectedNode.key > 0
        }));

        dispatch(action_setBoardConfigTemplateTypeList(templateTypeList));
        dispatch(action_setBoardConfigTemplateProperty("templateTypeSelected", selectedNode))
    };

    const onGoToBoard = () => {
        __onGoToBoard(5)
    };

    return (
        <Card className="board-element-form h-100">
            <ProfileVerify />
            <Card.Header className="card-header-compact">
                <Card.Title className="justify-content-between">
                    <Row>
                        <Col className='d-flex'>
                            <b>{t('data-lang-lbl-name')}: </b>
                            <div>&nbsp;{templateConfig.title !== "" ? templateConfig.title : t('data-lang-lbl-unasigned')}</div>             
                        </Col>
                        <Col className='col-auto me-auto d-flex'>
                            <div className="toolbar d-flex">
                                {
                                    !created &&
                                    <>
                                        <Stack id='btnSelectElementType' horizontal verticalAlign="center" className='border-end pe-2'>
                                            <Row className='m-0 p-0'>
                                                <Col className='m-0 p-0 pe-1 col-auto ms-auto' style={{fontSize: "24px"}}>
                                                    <CValidator isInValid={!isValidForm.templateType} inValidText={"*"} />
                                                </Col>
                                                <Col className='m-0 p-0'>
                                                    <CLabel labelText={t('data-lang-lbl-templatetype')} className="fontSizeNormal pb-2" />
                                                </Col>
                                                <Col className='m-0 p-0' style={{border: !isValidForm.templateType ?"1px solid red" : undefined}}>
                                                    <Dropdown
                                                        id='dropdownSelectTempleteType'
                                                        className="templateTypeDropdown"
                                                        placeholder={t('data-lang-placeholder-selectoption')}
                                                        options={ templateTypeList ? (templateTypeList.filter(x => (isReportType === false ? (x.key != enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED) : (x.key === enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED)))) : [] }
                                                        selectedKey={isReportType !== true ?
                                                            (templateConfig.templateTypeSelected ?
                                                            templateConfig.templateTypeSelected.key : undefined) : enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED}
                                                        onChange={ onChangeTemplateType }
                                                        disabled={isReportType === true}
                                                        required={false}
                                                    />
                                                </Col>
                                            </Row>
                                        </Stack>
                                        <div style={{border: isValidForm.title && isValidForm.elementType && isValidForm.appElementType ? undefined : "1px solid red"}}>
                                        <Stack id='btnConfigureBoard' horizontal verticalAlign="center" className='border-end pe-2'>
                                               <IconButton iconProps={{iconName: "Settings"}} onClick={() => onOpenConfigureBoardPanel()} />
                                                <Label className="cursor-pointer" onClick={() => onOpenConfigureBoardPanel()}>
                                                    {
                                                        window.location.href.toLocaleLowerCase().indexOf('configuration/board') !== -1 ?
                                                        t('data-lang-boxname-configureboard') :
                                                        t('data-lang-boxname-configurereport')
                                                    }
                                                </Label> 
                                        </Stack>
                                        </div>
                                        <Stack id='btnAddContainer' horizontal verticalAlign="center" className='border-end pe-2'>
                                            <IconButton iconProps={{ iconName: "Add" }} onClick={() => onAddItemToLayout()} />
                                            <Label className="cursor-pointer" onClick={() => onAddItemToLayout()}>{t('data-lang-btn-addcontainer')}</Label>
                                        </Stack>
                                        <Stack id='btnSaveBoard' horizontal verticalAlign="center" className='pe-2'>
                                            <IconButton iconProps={{ iconName: "Save" }} onClick={() => onSaveTemplate()} />
                                            <Label className="cursor-pointer" onClick={() => onSaveTemplate()}>{t('data-lang-btn-savetamplate')}</Label>
                                        </Stack>
                                        <TeachBubbleMultiSteps
                                            inputParam_ButtonId={"btnHelp"}
                                            inputParam_Title={t('data-lang-helptext-title')}
                                            inputParam_ClassName="my-auto"
                                            inputParam_ButtonClassName="pb-2"
                                            inputParam_DirectionalHint={DirectionalHint.topCenter}
                                            inputParam_Steps={__enum_TeachBoardConfig.map(x => {return t(x)})}
                                            inputParam_NextTechStepType={"BoardConfig"}
                                        />
                                    </>
                                }
                                {
                                    created &&
                                    <Stack id='btnAddContainer' horizontal verticalAlign="center" className='border-end pe-2'>
                                        <IconButton iconProps={{ iconName: "Go" }} onClick={() => onGoToBoard()} />
                                        <Label className="cursor-pointer" onClick={() => onGoToBoard()}>Ir a tablero</Label>
                                    </Stack> 
                                }
                            </div>
                        </Col>
                    </Row>
                </Card.Title>
            </Card.Header>
            <Card.Body className='pt-0' style={{minHeight: "1000px"}}>
                <Row>
                    <Col>
                    <div style={{position: "absolute", width: "100%", right: "16px"}} className='ps-3'>
                        <MessageBox  
                            inputParam_Position='absolute'
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </div>
                    </Col>
                </Row>
                <Row className='pt-4'>
                    <Col>
                        <ResponsiveGridLayout
                            ref={gridLayoutRef}
                            className="layout"
                            layouts={layouts}
                            isDraggable={!created}
                            isDroppable={!created}
                            isResizable={!created}
                            autoSize={true}
                            measureBeforeMount={layoutConfiguration.measureBeforeMount}
                            breakpoints={layoutConfiguration.breakpoints}
                            cols={layoutConfiguration.cols}
                            rowHeight={layoutConfiguration.rowHeight}
                            draggableHandle={!created ? layoutConfiguration.draggableHandle : undefined}
                            margin={layoutConfiguration.margin}
                            onLayoutChange={onLayoutChange}
                        >
                            {layouts.lg.map((container) => (
                                <div key={container.i} className="gridItem" style={
                                        {
                                            height: `${(layoutsComponentTypes.find(x => x.i === container.i) !== undefined ? layoutsComponentTypes.find(x => x.i === container.i).minHeigthPoints : container.h) * 50}px`,
                                            width: `${(layoutsComponentTypes.find(x => x.i === container.i) !== undefined ? layoutsComponentTypes.find(x => x.i === container.i).minWidthPoints : container.w) * 48.5}px`,
                                        }
                                    }
                                >
                                    {generateContainer(container)}
                                </div>
                            ))}
                        </ResponsiveGridLayout>
                    </Col>
                </Row>
            </Card.Body>
            <SidePanelModifyContainer
                inputParam_IsPanelOpen={isPanelModifyContainerOpen}
                inputParam_SetterIsPanelOpen={setIsPanelModifyContainerOpen}
                inputParam_Container={selectedContainer}
                inputParam_ContainerComponentType={layoutsComponentTypes.find(x => x.i === selectedContainer.i)}
                inputParam_SetterContainerData={onSetContainerData}
            />
            <SidePanelConfigure
                inputParam_IsPanelOpen={isPanelConfigureBoardOpen}
                inputParam_SetterIsPanelOpen={setIsPanelConfigureBoardOpen}
                inputParam_StructureTitle={templateConfig.title}
                inputParam_BoardSelected={templateConfig.elementSelected}
                inputParam_SetterBoardData={onSetBoardData}
            />
        </Card>
    );
}

export default BoardConfiguration;





  